import { Text } from '~/shared/components/Text';
import useBrandFiltering from '../useBrandFiltering';
import { List, Section, StyledLinkAnimationText } from './styled';
import { Link } from '~/shared/components/Link';
import { SkeletonLoader } from '~/shared/components/SkeletonLoader';
import { useTranslations } from '~/services/umbraco/hooks';

type Props = {
    existingLettersByBrand: ReturnType<typeof useBrandFiltering>['existingLettersByBrand'];
    isError: boolean;
    isLoading: boolean;
};

export default function Brands({ isLoading, existingLettersByBrand, isError }: Props) {
    const { translate } = useTranslations();
    if (isLoading || !existingLettersByBrand) {
        return <Skeleton />;
    }

    if (isError) {
        return (
            <StyledLinkAnimationText noContent>
                {translate('brands.fetchingError')}
            </StyledLinkAnimationText>
        );
    }

    if (existingLettersByBrand.length === 0) {
        return (
            <StyledLinkAnimationText noContent>
                {translate('brands.noBrands')}
            </StyledLinkAnimationText>
        );
    }

    return existingLettersByBrand.map(([letter, brands], index) => (
        <Section id={letter} key={index}>
            <Link href={`#${letter}`}>
                <Text variant="display2">{letter}</Text>
            </Link>

            <List>
                {brands.map((brand, index) => (
                    <li key={index}>
                        <Link href={brand.url} withIcon multipleElements>
                            <StyledLinkAnimationText>{brand.name}</StyledLinkAnimationText>
                        </Link>
                    </li>
                ))}
            </List>
        </Section>
    ));
}

function Skeleton() {
    return Array.from({ length: 5 }).map((_, index) => (
        <Section key={index}>
            <SkeletonLoader width={20} height={35} />

            <List>
                {Array.from({ length: 7 }).map((_, index) => (
                    <SkeletonLoader key={index} width={100} height={23} />
                ))}
            </List>
        </Section>
    ));
}
